export const PermissionActions = {
  CREATE: 'create',
  VIEW: 'view',
  EDIT: 'edit',
  DELETE: 'delete',
  MANAGE: 'manage',
  PUBLISH: 'publish',
};

export const PermissionSubjects = {
  DASHBOARD: 'dashboard',
  CONTENT_ITEMS: 'contentItems',
  USER_MANAGEMENT: 'userManagement',
  ACTIVITY_LOGS: 'activityLogs',
};
